import { createInvalidStateError } from '../factories/invalid-state-error';
import { CONTEXT_STORE } from '../globals';
export const getNativeContext = (context) => {
    const nativeContext = CONTEXT_STORE.get(context);
    if (nativeContext === undefined) {
        throw createInvalidStateError();
    }
    return nativeContext;
};
//# sourceMappingURL=/build/es2018/helpers/get-native-context.js.map